import api from "./api";

export interface ResponseData {
  responses: Array<{
    id: string;
    survey_id: string;
    question_id: string;
    responder_id: string;
    selected_option_id: string;
    response_time_seconds: number | null;
    submitted_at: string;
    survey?: {
      id: string;
      title: string;
      status: string;
    };
  }>;
}

export interface AvailableSurvey {
  id: string;
  title: string;
  description: string | null;
  reward_per_response: string;
  response_window_hours: number;
  contract_survey_id: string | null;
}

export const responsesService = {
  async getMy(params?: { limit?: number; offset?: number }) {
    const response = await api.get<{ success: boolean; data: ResponseData }>("/responses/my", { params });
    return response.data.data;
  },

  async getHistory(params?: { limit?: number; offset?: number }) {
    const response = await api.get<{ success: boolean; data: ResponseData }>("/responses/history", { params });
    return response.data.data;
  },

  async respondToSurvey(surveyId: string, responses: Array<{ question_id: string; selected_option_id: string; response_time_seconds?: number }>) {
    const response = await api.post<{ success: boolean; data: { responses: unknown[]; reward_earned: string } }>(`/responses/surveys/${surveyId}/respond`, { responses });
    return response.data.data;
  },

  async getAvailable(params?: { limit?: number; offset?: number }) {
    const response = await api.get<{ success: boolean; data: { surveys: AvailableSurvey[] } }>("/responses/surveys", { params });
    return response.data.data;
  },
};
